<div [class.hidden-shared-block-controls]="isBlockHidden" class="small-block-controls">
    <div class="btn-group" dropdown (onShown)="isShowDropDownMenu(true)" (onHidden)="isShowDropDownMenu(false)">
        <button class="btn-control dropdown-toggle" id="button-basic" dropdownToggle type="button">
            <span class="sp-icon icon-option-horizontal"> </span> <small>{{ "control_block" | translate }}</small>
        </button>
        <ul
            *dropdownMenu
            id="dropdown-basic"
            class="dropdown-menu dropdown-menu-right dropdown-custom-right"
            role="menu"
            aria-labelledby="button-basic"
        >
            <li role="menuitem">
                <a class="dropdown-item" (click)="selectAction()">
                    <span class="sp-icon icon-pencil"> </span>
                    {{ "edit" | translate }}
                </a>
            </li>
            <li role="menuitem">
                <a class="dropdown-item" (click)="copyAction()">
                    <span class="sp-icon icon-copy"> </span>
                    {{ "duplicate" | translate }}
                </a>
            </li>
            @if (saveBlockToGallery) {
                <li role="menuitem">
                    <a class="dropdown-item" (click)="saveBlockToLibraryAction()">
                        <span class="sp-icon icon-heart-empty"> </span>
                        {{ "save_to_gallery" | translate }}
                    </a>
                </li>
            }
            @if (!isBlockHidden) {
                <li role="menuitem">
                    <a class="dropdown-item" (click)="hideBlockAction()">
                        <span class="sp-icon icon-unwatch"> </span>
                        {{ "shared_block_hide" | translate }}
                    </a>
                </li>
            }
            @if (isBlockHidden) {
                <li role="menuitem">
                    <a class="dropdown-item" (click)="showBlockAction()">
                        <span class="sp-icon icon-watch"> </span>
                        {{ "shared_block_show" | translate }}
                    </a>
                </li>
            }
            <li><hr /></li>
            <li role="menuitem">
                <a class="dropdown-item" (click)="deleteAction()">
                    <span class="sp-icon icon-bin color-danger"> </span>
                    {{ "delete" | translate }}
                </a>
            </li>
        </ul>
    </div>
</div>

<div [class.hidden-shared-block-controls]="isBlockHidden" class="main-controls">
    @if (!isBlockHidden) {
        <button
            class="btn-control click-outside-close-prevent btn-edit-action"
            [tooltip]="selectActionTooltip"
            (click)="selectAction()"
        >
            <span class="sp-icon icon-pencil"> </span>
        </button>
    }
    <div
        class="btn-group"
        dropdown
        (onShown)="isShowDropDownMenu(true)"
        (onHidden)="isShowDropDownMenu(false)"
        container="body"
    >
        <button class="btn-control dropdown-toggle" id="button-basic" dropdownToggle type="button">
            <span class="sp-icon icon-option-horizontal"> </span>
        </button>
        <ul
            *dropdownMenu
            id="dropdown-basic"
            class="dropdown-menu dropdown-menu-right dropdown-custom-right"
            role="menu"
            aria-labelledby="button-basic"
        >
            <li role="menuitem">
                <a class="dropdown-item" (click)="copyAction()">
                    <span class="sp-icon icon-copy"> </span>
                    {{ "duplicate" | translate }}
                </a>
            </li>
            @if (saveBlockToGallery) {
                <li role="menuitem">
                    <a class="dropdown-item" (click)="saveBlockToLibraryAction()">
                        <span class="sp-icon icon-heart-empty"> </span>
                        {{ "save_to_gallery" | translate }}
                    </a>
                </li>
            }
            @if (!isBlockHidden) {
                <li role="menuitem">
                    <a class="dropdown-item" (click)="hideBlockAction()">
                        <span class="sp-icon icon-unwatch"> </span>
                        {{ "shared_block_hide" | translate }}
                    </a>
                </li>
            }
            @if (isBlockHidden) {
                <li role="menuitem">
                    <a class="dropdown-item" (click)="showBlockAction()">
                        <span class="sp-icon icon-watch"> </span>
                        {{ "shared_block_show" | translate }}
                    </a>
                </li>
            }
            <li><hr /></li>
            <li role="menuitem">
                <a class="dropdown-item" (click)="deleteAction()">
                    <span class="sp-icon icon-bin color-danger"> </span>
                    {{ "delete" | translate }}
                </a>
            </li>
        </ul>
    </div>
</div>
